import { Component, OnInit} from '@angular/core';
import {FastenService} from '../../services/fasten.service';
import {ConfigService} from '@shared-library';
import {FormHealthSystemRequest} from '@shared-library';
import {Router} from '@angular/router';
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FdkAlertComponent, FdkButtonComponent, FdkIllustrationComponent, FdkInputComponent, FdkSpinnerComponent} from 'fasten-design-kit';

@Component({
    selector: 'app-form-health-system-request',
    templateUrl: './form-health-system-request.component.html',
    styleUrls: ['./form-health-system-request.component.css'],
    standalone: true,
    imports: [
      CommonModule,
      ReactiveFormsModule,
      FormsModule,
      FdkSpinnerComponent,
      FdkAlertComponent,
      FdkInputComponent,
      FdkButtonComponent,
      FdkIllustrationComponent
    ],
})
export class FormHealthSystemRequestComponent implements OnInit {
  formRequestHealthSystem: FormHealthSystemRequest = {} as FormHealthSystemRequest

  loading: boolean = false
  submitSuccess: boolean = false
  errorMsg: string = ""

  constructor(
    private router: Router,
    private configService: ConfigService,
    private vaultApi: FastenService,
  ) { }

  ngOnInit(): void {
    this.resetForm()
  }
  resetForm() {
    this.submitSuccess = false
    let requestForm = new FormHealthSystemRequest()
    requestForm.email = this.configService.vaultProfileConfig$.email || ''
    requestForm.name = this.configService.searchConfig$.searchFilter?.query || ""
    requestForm.street_address = ''
    requestForm.website = ''

    this.formRequestHealthSystem = requestForm
  }

  submitForm() {
    this.loading = true
    this.vaultApi.requestHealthSystem(this.formRequestHealthSystem).subscribe((resp: any) => {
        this.loading = false
        this.submitSuccess = true
        //show success toast? close modal?
      },
      (err)=>{
        this.loading = false
        console.error("an error occurred during request submission",err)
        this.errorMsg = err || "An error occurred while submitting your request. Please try again later."
      })
  }

  dismiss(){
    this.router.navigateByUrl('dashboard')
  }
}
